// Application Constants
export const CONTACT_INFO = {
  PHONE: '+6282332091818 (Anthony)',
  
  ADDRESS: 'Jl. Merpati Raya, Sawah Lama, Kec. Ciputat, Kota Tangerang Selatan, Banten 15413'
};

export const COMPANY_INFO = {
  NAME: 'Citra Garden Bintaro',
  COPYRIGHT: '© 2025 Citra Garden Bintaro. All Rights Reserved.',
  POWERED_BY: 'Powered by: Linktown'
};

export const NAVIGATION_LINKS = {
  ABOUT: '/#about',
  PROMO: '/#promo',
  BISCHOFIA: '/#bischofia',
  CALAMUS: '/#calamus',
  DALBERGIA : '/#dalbergia',
  SURROUNDING: '/#surrounding',
  LOCATION: '/#lokasi',
  NAVBAR: '/#navbar',
  PRIVACY_POLICY: '/privacy-policy'
};
